var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6038 25.4816L34.6886 24.2292C33.4382 25.1116 31.7238 25.1967 30.3656 24.3074C30.3656 24.3074 24.534 20.4978 23.9958 20.1407C23.3538 19.7113 22.5535 19.6846 21.8689 20.1298C21.1864 20.5739 15.4754 24.3074 15.4754 24.3074C14.1162 25.1967 12.4048 25.1116 11.1514 24.2292L9.23922 25.4816C7.63466 26.5312 7.18357 28.6808 8.23217 30.2844C9.28077 31.8899 11.4314 32.341 13.036 31.2905L21.9402 25.4707C22.6415 25.0384 23.2123 25.0384 23.9048 25.4687L32.8051 31.2905C34.4106 32.341 36.5603 31.8899 37.6098 30.2844C38.6565 28.6808 38.2073 26.5312 36.6038 25.4816Z",
    fill: "#7CB142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2724 14.7036C22.4682 14.5829 22.6997 14.5146 22.947 14.5146C23.1894 14.5146 23.4159 14.5809 23.6118 14.6977C23.9768 14.9163 27.8547 17.4854 27.8547 17.4854C29.1407 18.3252 30.7938 18.1551 31.8859 17.1737L34.087 18.6161C35.4511 19.5054 35.834 21.3345 34.9427 22.6987C34.0504 24.0619 32.2232 24.4457 30.859 23.5534C30.859 23.5534 24.5358 19.4302 23.9214 19.078C23.3071 18.7239 22.581 18.7091 21.9499 19.085C21.4374 19.3887 14.9826 23.5534 14.9826 23.5534C13.6313 24.3695 11.7903 24.0619 10.899 22.6987C10.0077 21.3345 10.3905 19.5054 11.7537 18.6161L13.9568 17.1737C15.0479 18.1551 16.6999 18.3252 17.9879 17.4854C17.9879 17.4854 21.8895 14.9361 22.2724 14.7036Z",
    fill: "#528A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6849 13.6571L28.3492 16.7278C29.4661 17.4568 30.9628 17.1423 31.6929 16.0264C32.4219 14.9115 32.1084 13.4138 30.9925 12.6827L23.6513 7.87994C23.1853 7.59602 22.6581 7.59602 22.205 7.87598L14.8509 12.6827C13.7331 13.4138 13.4195 14.9115 14.1486 16.0264C14.8806 17.1423 16.3754 17.4568 17.4922 16.7278L22.2238 13.6552C22.4454 13.5088 22.6769 13.4059 22.9529 13.4059C23.2289 13.4059 23.4653 13.5088 23.6849 13.6571Z",
    fill: "#004711"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9291 35.1761L24.1136 28.935C23.8109 28.4196 23.3697 28.1574 22.9206 28.1436C22.4715 28.1574 22.0293 28.4196 21.7266 28.935L17.911 35.1761C17.4164 35.9418 17.5331 37.1635 18.8983 37.1635H26.9419C28.306 37.1635 28.4238 35.9418 27.9291 35.1761Z",
    fill: "#004711"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/신영증권-46.cf550850fdb21c8cae08616ba9c5fcb5.svg";
export { ForwardRef as ReactComponent };